// Import React and required dependencies
import { Box, Typography, Alert, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Component to display customer name and verification status in a modal
const RedeemNameMismatchModal = ({
  fosName,
  bankVerifiedName,
  open,
  handleClose,
}) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '70%', md: 400, lg: 400 },
          bgcolor: 'background.paper',
          border: '2px solid',
          borderColor: 'error.main',
          boxShadow: 24,
          p: 4,
          borderRadius: '8px',
       
        }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'grey.500',
          }}>
          <CloseIcon />
        </IconButton>
        <Typography
          id="modal-title"
          variant="h5"
          color={'red'}
          fontWeight={'bold'}
          fontSize={'2.5rem'}
          gutterBottom
        
          marginBottom={'30px'}>
          FOS Name Verification Failed
        </Typography>
        <Typography id="modal-description" variant="body1"  fontSize={'2rem'} gutterBottom>
          <strong>FOS name in VJ system:</strong>{' '}
          {fosName || 'Not Available'}
        </Typography>
        <Typography variant="body1"  fontSize={'2rem'} gutterBottom>
          <strong>Name verified by Bank/UPI:</strong>{' '}
          {bankVerifiedName || 'Not Available'}
        </Typography>
        <Alert severity="error" sx={{ marginTop: '20px' }}>
          <Typography variant="body2"  fontSize={'1.6rem'}>
            <strong>Important:</strong> Your name in our database doesn’t match
            with the bank/UPI information. Please raise a payment query using the option below the "Confirm & Redeem" button.
          </Typography>
        </Alert>
      </Box>
    </Modal>
  );
};

export default RedeemNameMismatchModal;